// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// components
import { FormAddCashInMethod } from '../../forms/FormAddCashInMethod/FormAddCashInMethod';

export interface DialogAddCashInMethodProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

export const DialogAddCashInMethod = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogAddCashInMethodProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addCashInMethod'),
					loading: isLoading,
					form: 'form-add-cash-in-method',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('addCashInMethod'),
				variant: 'h3',
			}}>
			<FormAddCashInMethod onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
